module.exports = __webpack_public_path__ + "static/pexels2-6c660189adc083346a324177bdbde1db.png";